import React, { useEffect, useRef } from "react";
import { useState } from "react";
import { logos, rs } from "../../assets";
import MenuList from "../MenuList";
import "./index.css";
import { Link } from "react-router-dom";

const Footer = ({ windowDimension }) => {
  const offset = useRef(null);
  const footer = useRef(null);
  const [offsetMargin, setOffsetMargin] = useState(null);

  useEffect(() => {
    return setOffsetMargin(footer.current.clientHeight);
  }, [windowDimension]);

  const RSlist = [
    {
      href: "https://www.instagram.com/",
      src: rs.ig.src,
      alt: rs.ig.alt,
    },
    {
      href: "https://www.facebook.com/",
      src: rs.fb.src,
      alt: rs.fb.alt,
    },
    {
      href: "https://www.linkedin.com/company/replaceit/",
      src: rs.in.src,
      alt: rs.in.alt,
    },
  ];

  return (
    <>
      <div
        className="offset"
        style={{
          height: offsetMargin + "px",
        }}
        ref={offset}
      ></div>
      <footer
        className="footer flex flexCol vertCenter justifyEnd"
        ref={footer}
      >
        <div className="container-lg flex flexCol alignCenter">
          <img
            className="footerLogo"
            src={logos.isoFooter.src}
            alt={logos.isoFooter.alt}
          />
          <p className="footerOffices" style={{ color: '#888', marginBottom: '20px', textAlign: 'center' }}>
            Montevideo, Uruguay | San Luis 1632, Mar del Plata, Argentina <br />
            <a href="mailto:nlaugas@replaceit.ai" style={{ color: '#fff', textDecoration: 'none' }}>nlaugas@replaceit.ai</a>
          </p>
          <nav className="menuFooter flex flexRow gap">
            {MenuList.map((menu, index) =>
              menu.external ? (
                <a
                  className="menuLinkFooter"
                  href={menu.href}
                  target="_blank"
                  rel="noreferrer"
                  key={index}
                >
                  {menu.text}
                </a>
              ) : (
                <Link className="menuLinkFooter" to={menu.href} key={index}>
                  {menu.text}
                </Link>
              )
            )}
          </nav>
          <div className="rs flex flexRow justifySpace">
            {RSlist.map((social, index) => (
              <a
                href={social.href}
                target="_blank"
                rel="noreferrer"
                key={index}
              >
                <img src={social.src} alt={social.alt} />
              </a>
            ))}
          </div>
          <div className="footerCopy flex flexRow justifySpace">
            <p>© 2026 Replace. All rights reserved.</p>
            <p>
              <a href="#priv">Privacy Policy</a> |{" "}
              <a href="#cookies">Cookie Policy</a> |{" "}
              <a href="#term">Terms & Conditions</a>
            </p>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;
